import { FC } from 'react';
import { MotifIcon } from '@ey-xd/motif-react';

type IconProps = React.HTMLAttributes<HTMLSpanElement> & {
    src: string;
    className?: string;
    title?: string;
    onClick?: (event?: any) => void;
    ariaLabel?: string;
    disabled?: boolean;
};

const Icon: FC<IconProps> = ({ src, className, title, ariaLabel, onClick, ...rest }: IconProps) => {
    return (
        <MotifIcon
            className={className ? className : 'motif-icon'}
            data-testid={'motif-icon'}
            src={src}
            title={title}
            onClick={onClick}
            aria-label={ariaLabel}
            {...rest}
        />
    );
};

export default Icon;
